import { jsx as _jsx } from "react/jsx-runtime";
import { PreplaningIcon } from '~/elements/Icons';
import { CommunityIcon, DonationIcon, DoveIcon, FlowerIcon, GriefSupportIcon, TreeIcon, } from '~/elements/TributeIcons';
const getTributeIcon = (label) => {
    switch (label) {
        case 'Plant a Tree':
            return _jsx(TreeIcon, {});
        case 'Send Flowers':
            return _jsx(FlowerIcon, {});
        case 'Buy Tribute Blanket':
            return _jsx(DoveIcon, {});
        case 'Get Grief Support':
            return _jsx(GriefSupportIcon, {});
        case 'Make a Donation':
            return _jsx(DonationIcon, {});
        case 'Community Events':
            return _jsx(CommunityIcon, {});
        case 'Pre-plan a Funeral':
            return _jsx(PreplaningIcon, { width: 24, height: 24, stroke: '#fff' });
        default:
            return null;
    }
};
export { getTributeIcon };
